import {createFileRoute} from '@tanstack/react-router'
import CourtsListPage from "../../../../../user/courts/List.tsx";

export const Route = createFileRoute('/_app/clubs/$club_uid/courts/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <CourtsListPage />
}
